export const flightTimeLines = (s) => (s || "").split(" · ").map((x) => x.trim()).filter(Boolean);

export function FlightTime({ value, testId }) {
  const lines = flightTimeLines(value);
  if (!lines.length) return "—";
  return (
    <span className="flex flex-col" data-testid={testId}>
      {lines.map((l) => <span key={l} className={l.startsWith("Total") ? "text-white" : ""}>{l}</span>)}
    </span>
  );
}
